import * as HLF from "html-living-framework";
import {HoverableButton, TextureButton} from "../core/Button";
import {Callback, Mix} from "../core/Reflection";
import {TransformBackup} from "../core/TransformBackup";
import {TrashType} from "../data/TrashType";
import { TrashItem } from "./TrashItem";

export class TrashItemReturn extends TrashItem {
    public pickedUp: boolean;

    constructor(trashType: TrashType, texture: string, voiceoverA: string, voiceoverB: string, voiceoverC: string) {
        super(trashType, texture, voiceoverA, voiceoverB, voiceoverC);
        this.pickedUp = true;
        this.alpha = 0;
        this.enabled = false;
    }
}
